import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  href = 'https://tryloomy.com/products/loomy-creatine-gummies',
  ...props
}: CTAButtonProps) {
  const baseStyles = 'font-sans font-bold uppercase tracking-wide transition-colors duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg min-h-[44px]';
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 md:px-6 py-3 text-sm md:text-base',
    lg: 'px-6 md:px-8 py-3 md:py-4 text-base md:text-lg lg:text-xl'
  };
  const colorStyles = 'bg-accent hover:bg-accent-hover text-white';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (props.onClick) {
      props.onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${colorStyles}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-1">
      {children || 'Get Loomy Now'}
      {showIcon && <ArrowRight className="w-4 h-4 md:w-5 md:h-5" strokeWidth={3} data-id="element-2" />}
    </motion.button>;
}